import axios from 'axios';

const cache = {};

export const cachedRequest = async url => {
  if (!url) {
    return { data: '' };
  }

  if (cache[url]) {return cache[url];}

  const response = axios.get(url);
  cache[url] = response;

  return response;
};
